module.exports = __webpack_public_path__ + "../resources/img/ic_re_sleet_solid.37a98767.svg";